import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

::slotted(*) {
  margin: 0;
  font-size: inherit;
}

a {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 6px;
  background-color: var(--contrast-light);
}

xs-icon-progress {
  margin-right: 16px;
}

section {
  margin-right: 32px;
  color: var(--dark-text);
  font-size: var(--font-size-lg);
}

footer {
  font-size: var(--font-size-sm);
  color: var(--dark-text-secondary);
}

ef-icon {
  color: var(--dark-text);
  font-size: var(--font-size-xl);
  margin-left: auto;
}
`;
export default styles;
